export const WEB_URL = "https://journal.lukedupin.com"
export const WS_URL = "wss://journal.lukedupin.com"


